import { render, staticRenderFns } from "./SiteSettings.vue?vue&type=template&id=ab10a3ce&"
import script from "./SiteSettings.vue?vue&type=script&lang=js&"
export * from "./SiteSettings.vue?vue&type=script&lang=js&"
import style0 from "./SiteSettings.vue?vue&type=style&index=0&id=ab10a3ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports